import { z } from "zod";

export const facultySchema = z.object({
	id: z.string(),
	name: z.string(),
});

export const subspecialtySchema = z.object({
	id: z.string(),
	name: z.string(),
});

export const dissertationSchema = z.object({
	id: z.number(),
	key: z.string(),
	faculty: facultySchema,
	subspecialty: subspecialtySchema,
	title: z.string(),
	abstract: z.string(),
	status: z.number(),
	status_name: z.string(),
	status_description: z.string(),
	submitted_at: z.string().nullable().optional(),
	last_updated: z.string(),
	resubmission_enabled: z.boolean().optional(),
	can_submit_final: z.boolean().optional(),
	final_submission_enabled: z.boolean().optional(),
	final_submission_deadline: z.string().nullable().optional(),
	final_submission_deadline_passed: z.boolean().optional(),
	final_submission_remarks: z.string().nullable().optional(),
	final_submitted_at: z.string().nullable().optional(),
	final_submission_count: z.number().optional(),
	has_final_dissertation: z.boolean().optional(),
	can_edit: z.boolean(),
	can_delete: z.boolean(),
});

export const dissertationSubmissionSchema = z.object({
	title: z.string().min(1, "Title is required"),
	abstract: z.string().min(1, "Abstract is required"),
	dissertation_file: z.instanceof(File).optional(),
	dissertation_docx: z.instanceof(File).optional(),
	proposal_file: z.instanceof(File).optional(),
	// proposal_docx: z.instanceof(File, { message: "Proposal Word file is required" }),
	cover_letter_file: z.instanceof(File).optional(),
	// cover_letter_docx: z.instanceof(File, { message: "Cover letter Word file is required" }),
	turnitin_score_file: z.instanceof(File).optional(),
});

export type Faculty = z.infer<typeof facultySchema>;
export type Subspecialty = z.infer<typeof subspecialtySchema>;
export type Dissertation = z.infer<typeof dissertationSchema>;
export type DissertationSubmissionData = z.infer<typeof dissertationSubmissionSchema>;
export type CreateDissertationData = DissertationSubmissionData;
